import { Flex, Text, Image } from '@chakra-ui/react';

import { HSeparator } from 'components/separator/Separator';
import User from '../../../api/user';
import Logo from '../../../assets/img/auth/Logo.png';

export function SidebarBrand() {
  const userInfo = User.GetInfo();
  const userType = userInfo && userInfo.type ? userInfo.type : null;
  const fullName = userInfo
    ? [userInfo.firstName, userInfo.lastName].filter(Boolean).join(' ')
    : null;

  return (
    <Flex align="center" direction="column" marginTop="50px">
      <Image src={Logo} alt="Logo" w="60%" marginBottom="16px" />
      {userType !== null && (
        <Text fontSize="2xl" fontWeight="bold" style={{ paddingBottom: fullName ? 8 : 30 }}>
          {userType === 1 ? 'admin' : 'for business'}
        </Text>
      )}
      {fullName && (
        <Text fontSize="md" color="gray.500" style={{ paddingBottom: 30 }}>
          שלום, {fullName}
        </Text>
      )}
      <HSeparator mt="30px" mb="20px" />
    </Flex>
  );
}

export default SidebarBrand;
